var vmFormQA = null;
var recaptchaError = "";
//function isCaptchaChecked() {
//    return grecaptcha && grecaptcha.getResponse().length !== 0;
//}
function Callback() {
    vmFormQA.recaptchaCallback()
}
if (document.getElementById("formQA")) {
    Vue.filter('highlight', function (stringToSearch, searchTerm) {
        if (searchTerm === '') return stringToSearch;
        var s = '(' + searchTerm.trim().replace(/ +/g, '|') + ')';
        var iQuery = new RegExp(s, "ig");
        return stringToSearch.toString().replace(iQuery, function (matchedText, a, b) {
            return ('<span class=\'highlight\'>' + matchedText + '</span>');
        });
    });
    Vue.component('v-select', VueSelect.VueSelect);
    Vue.use(window.vuelidate.default);
    const { required, requiredIf, sameAs, email, numeric, maxLength, helpers } = window.validators;
    const phone = helpers.regex('phone', /^[0-9 ()+-]+$/)
    vmFormQA = new Vue({
        el: '#formQA',
        data: () => ({
            form: {
                firstNameQA: "",
                surnameQA: "",
                emailQA: "",
                phoneQA: "",
                organisationQA: "",
                organisationIdQA: "",
                otherOrganisationQA: "",
                mprnQA: "",
                descQA: "",
                filesQA: [],
                tandcQA: false,
                cmsVersionQA: null
            },
            submitStatus: "",
            loading: false,
            organisationsQAList: [],
            showDropdownList: false,
            rcapt_sig_key: captchaKey,
            rcapt_id: 0,
            error: recaptchaError,
            serverSideErrors: [],
            info: null,
            isGasConsumerQuery: typeof isGasConsumerQuery !== 'undefined' ? isGasConsumerQuery === "True" ? true : false : false,
            allowNotListedOrganisation: typeof allowNotListedOrganisation !== 'undefined' ? allowNotListedOrganisation === "True" ? true : false : false,
            queryType: queryType,
            cmsVersionShow: cmsVersionShow,
            cmsVersionRequired: cmsVersionRequired,
            cmsDropdownList: cmsDropdownList,
            showOtherOrganisation: false
        }),
        validations: {
            form: {
                firstNameQA: {
                    required,
                    maxLength: maxLength(256)
                },
                surnameQA: {
                    required,
                    maxLength: maxLength(256)
                },
                emailQA: {
                    required,
                    maxLength: maxLength(100),
                    email
                },
                phoneQA: {
                    phone,
                    maxLength: maxLength(32)
                },
                organisationQA: {
                    maxLength: maxLength(256),
                    required: requiredIf(function () { return !this.isGasConsumerQuery }),
                    function() { return (this.isGasConsumerQuery && this.form.organisationQA.length == 0) || this.filteredItems != undefined && this.filteredItems.length >= 1 && this.form.organisationIdQA != ''  && this.form.organisationIdQA == this.filteredItems[0].id }
                },
                otherOrganisationQA: {
                    required: requiredIf(function () { return this.form.organisationIdQA === -1 })
                },
                mprnQA: {
                    maxLength: maxLength(100)
                },
                descQA: {
                    maxLength: maxLength(4000),
                    required
                },
                tandcQA: {
                    required,
                    sameAs: sameAs(() => true),
                },
                cmsVersionQA: {
                    required: requiredIf(function() { return this.cmsVersionRequired})
                }
            }
        },
        methods: {
            recaptchaCallback() {
                if (grecaptcha.getResponse().length == 0) {
                    this.error = "Complete captcha challenge";
                } else {
                    this.error = "";
                }
            },
            //addOrganisation() {
            //    this.form.organisationQA = this.otherOrganisationQA;
            //    this.otherOrganisationQA = "";
            //    this.showDropdownList = true
            //},
            organisationChanged() {
                this.form.organisationIdQA = '';
                this.form.otherOrganisationQA = '';
            },
            addFile(fileName) {
                this.form.filesQA.push(fileName)
            },
            removeFileByNameGuid(nameGuid) {
                if (this.form.filesQA && this.form.filesQA.length) {
                    for (var i = 0; i < this.form.filesQA.length; i++) {
                        if (this.form.filesQA[i].nameGuid === nameGuid) {
                            this.form.filesQA.splice(i, 1);
                            break;
                        }
                    }
                }
            },
            sendForm() {
                const self = this;
                let g_recaptcha_response = grecaptcha.getResponse();

                this.loading = true;
                var dataUrl = "/umbraco/api/ContactApi/FormSubmit";
                this.$v.form.$touch()
                if (this.$v.form.$invalid || g_recaptcha_response.length == 0) {
                    this.submitStatus = 'ERROR'
                    this.recaptchaCallback();
                    this.loading = false;
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("form").offset().top - 100
                    }, 2000)
                } else {
                    this.error = "";
                    this.loading = true;
                    axios.post(dataUrl,
                        {
                            IsGasConsumerQuery: self.isGasConsumerQuery.toString(),
                            QueryType: self.queryType,
                            FirstName: self.form.firstNameQA,
                            Surname: self.form.surnameQA,
                            Email: self.form.emailQA,
                            Phone: self.form.phoneQA,
                            OrganisationId: self.form.organisationIdQA,
                            OrganisationOther: self.form.otherOrganisationQA,
                            Mprn: self.form.mprnQA,
                            Description: self.form.descQA,
                            Files: self.form.filesQA,
                            CmsVersion: self.form.cmsVersionQA,
                            CaptchaVerification: g_recaptcha_response
                        },
                        {
                            headers: {
                                'Content-Type': 'application/json; charset=utf-8'
                            }
                        })
                        .then(response => {
                            this.info = response.data
                            this.loading = false;
                            logGAEvent("Help & Support", "Form Submit Success", document.location.href);
                            $([document.documentElement, document.body]).animate({
                                scrollTop: $("form").offset().top - 100
                            }, 2000)
                        })
                        .catch(error => {
                            if (error.response.data) {
                                if (error.response.data.ResponseCode) {
                                    this.info = error.response.data
                                }
                                else {
                                    if (error.response.data.constructor === Array) {
                                        for (var i = 0; i < error.response.data.length; i++) {
                                            this.serverSideErrors.push(error.response.data[i]);
                                        }
                                    }
                                    else {
                                        this.serverSideErrors.push(error.response.data);
                                    }
                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: $("form").offset().top - 100
                                    }, 2000)
                                }
                            }
                            this.loading = false;
                        });
                }
            },
            getOrganisations() {
                axios
                    .get('/umbraco/api/ContactApi/GetOrganisationList?gasSupplierList=' + this.isGasConsumerQuery.toString())
                    .then(response => (this.organisationsQAList = response.data))
            },
            matchWords: function (subject, words) {
                return words.every(el => subject.toLowerCase().includes(el.toLowerCase()));
            },
            back() {
                location.reload();
            },
            selectOrganisation(item) {
                this.form.organisationQA = item.combinedTitle,
                    this.form.organisationIdQA = item.id,
                    this.showDropdownList = false               
            }           
        },
        mounted() {
            this.getOrganisations();
        },
        computed: {
            showResponseMsg() {
                return this.info == null || this.info == undefined
            },
            showDropdown() {
                if (this.filteredItems && this.filteredItems.length && this.filteredItems != 'undefined' && this.showDropdownList) {
                    return true;
                } else { return false }
            },

            filteredItems() {
                const rg = this.form.organisationQA.split(/(\s+)/).filter(e => e.trim().length > 0)
                //if (this.form.organisationQA) {
                //    return this.organisationsQAList.filter(i => this.matchWords(i.combinedTitle, rg))
                //}
                const other = this.allowNotListedOrganisation ? [{ "id": -1, "shortCode": "OTHER", "name": "Organisation not listed?", "combinedTitle": "Organisation not listed?", "gasSupplier": false }] : []
                if (this.form.organisationQA) {
                    let fullMatchHandler = this.organisationsQAList.filter(i => i.combinedTitle === this.form.organisationQA)
                    if (fullMatchHandler.length === 1) {
                        return this.organisationsQAList.filter(i => i.combinedTitle === this.form.organisationQA)
                    } else {                        
                        return other.concat(this.organisationsQAList.filter(i => this.matchWords(i.combinedTitle, rg)))         
                    }
                }
            }
        },
        watch: {
            loading() {
                if (this.loading) {
                    $('.loader').css("display", "block")
                } else {
                    $('.loader').css("display", "none")
                }
            }
        }
    })
}
var uploadFilesSum = 0;
var upload = $("#filesQA").data("kendoUpload");

$("#filesQA").kendoUpload({
    async: {
        saveUrl: "/umbraco/api/ContactApi/SupportingDocumentationUpload",
        removeUrl: "/umbraco/api/ContactApi/SupportingDocumentationUploadRemove"
    },
    localization: {
        invalidFileExtension: '<div><strong>File upload error.</strong> File type not permitted.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.<span></div>',
        invalidMaxFileSize: '<div><strong>File upload error.</strong> 10MB limit exceeded.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.</span></div>',
        filesSumSizeLimit: '<div><strong>File upload error.</strong> 10MB limit exceeded.<br><span class="text-darkBlue">Additional files can be submitted later by replying to your confirmation email.</span></div>',
        dropFilesHere: "Drag and drop files here or ",
        select: "Browse"
    },
    select: onSelect,
    success: onSuccess,
    remove: onRemove,
    validation: {
        allowedExtensions: allowedExtensions,
        maxFileSize: fileSizeLimit
    },
    error: onError
});

function onSelect(e) {

    console.log(e);
    $.each(e.files, function (index, value) {
        if (uploadFilesSum > fileSizeLimit || value.size > fileSizeLimit || (uploadFilesSum + value.size) > fileSizeLimit || $('.k-file[data-uid]').length > limitOfFileNumber - 1 || ($('.k-file[data-uid]').length + index) > limitOfFileNumber - 1) {
            var files = e.files;
            files[index].validationErrors = ["filesSumSizeLimit"];
            var uid = files[index].uid;
            var entry = $(".k-file[data-uid='" + uid + "']");
            if (entry.length > 0) {
                entry.remove();
            }
        } else {
            if (!e.files[0].validationErrors) {
                uploadFilesSum += value.size;
            }
        }
    });
};
function onError(e) {
    var files = e.files;
    for (var i = 0; i < files.length; i++) {
        var uid = files[i].uid;
        var entry = $(".k-file[data-uid='" + uid + "']");
        if (entry.length > 0) {
            entry.remove();
        }
    }
}
function getFileInfo(e) {
    var files = e.files;
    for (var i = 0; i < files.length; i++) {
        return files[i].size
    }
}

function onSuccess(e) {
    if (e.operation !== 'remove') {
        var file = e.files[0]
        file.nameGuid = e.response;
        vmFormQA.addFile(file);
    }
};

function onRemove(e) {
    vmFormQA.removeFileByNameGuid(e.files[0].nameGuid)

    if ((uploadFilesSum >= getFileInfo(e) && !e.files[0].validationErrors)) {
        uploadFilesSum -= getFileInfo(e);
    }
    e.data = {
        nameGuid: e.files[0].nameGuid
    }
};